import { useCallback } from "react";

import type { PriceRankItem, PriceRankItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	onSetSelectedPriceRank: (input: PriceRankItem) => void;
};

export const useSelectedPriceRank = ({
	onSetSelectedPriceRank: _onSetSelectedPriceRank, //
}: Props) => {
	const onSetSelectedPriceRank = useCallback(
		(input: ForAutoGenerator<PriceRankItemInput, "">) => {
			_onSetSelectedPriceRank({
				priceRankID: input.priceRankID.value,
				color: input.color.value,
				name: input.name.value,
				rooms: input.rooms?.value?.map((room) => {
					return {
						roomID: room.roomID.value,
						roomName: room.roomName.value,

						prices: room.prices?.value?.map((item) => {
							return {
								adultNum: item.adultNum.value,
								price: {
									amount: item.price.amount.value,
									currencyType: item.price.currencyType.value,
								},
							};
						}),
					};
				}),
			} satisfies PriceRankItem);
		},
		[_onSetSelectedPriceRank],
	);

	return {
		onSetSelectedPriceRank,
	};
};
